import { aboutData } from '@/mocks/homeData';

export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1000px] mx-auto">
          <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
            <div className="flex-1 text-center lg:text-left">
              <span className="inline-block px-3 py-1 rounded-full bg-secondary-100 text-secondary-900 text-xs font-semibold mb-4">
                关于我们
              </span>
              <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-5">
                {aboutData.title}
              </h2>
              <p className="text-sm md:text-base text-foreground-500 leading-relaxed max-w-[560px] mx-auto lg:mx-0">
                {aboutData.description}
              </p>
            </div>

            <div className="grid grid-cols-2 gap-4 w-full max-w-[400px] lg:max-w-none lg:w-auto">
              {aboutData.stats.map((stat) => (
                <div
                  key={stat.label}
                  className="bg-background-100 rounded-2xl p-5 md:p-6 text-center border border-background-200/70"
                >
                  <div className="text-2xl md:text-3xl font-bold text-primary-500 font-heading mb-1">
                    {stat.value}
                  </div>
                  <div className="text-xs md:text-sm text-foreground-500">{stat.label}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}